<template lang="locale">
<div class="md-layout">

    <md-card>

        <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
                <md-icon>analytics</md-icon>
            </div>
            <h4 class="title">{{$t("g_title")}}</h4>
            <p class="category">{{$t("g_sub")}}</p>
        </md-card-header>

        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                    <p>{{$t("fecha")}}</p>
                    <month-picker-input v-model="selectedDate" lang="en" @input="fetchData" :no-default="true"></month-picker-input>
                    <md-button class="md-success pull-right" @click="print()">
                        <md-icon>print</md-icon>
                    </md-button>
                </div>
            </div>
            <div class="md-layout">

                <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                    <md-card>
                        <md-card-header class="md-card-header-text md-card-header-green">
                            <div class="card-text">
                                <h4 class="title">{{$t("g_inco")}}</h4>
                            </div>
                        </md-card-header>
                        <md-card-content>
                            <div id="chart_inco">
                                <apexchart ref="inco" type="heatmap" height="400" :options="chartOptions_inco" :series="[]"></apexchart>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>

                <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">

                    <md-card>
                        <md-card-header class="md-card-header-text md-card-header-green">
                            <div class="card-text">
                                <h4 class="title">{{$t("g_max")}}</h4>
                            </div>
                        </md-card-header>
                        <md-card-content>
                            <div id="chart_inco">
                                <apexchart style="margin:0 auto;" ref="soiled" type="heatmap" height="400" :options="chartOptions_soiled" :series="[]"></apexchart>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>

                <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                    <md-card>
                        <md-card-header class="md-card-header-text md-card-header-green">
                            <div class="card-text">
                                <h4 class="title">{{$t("g_max_alc")}}</h4>
                            </div>
                        </md-card-header>
                        <md-card-content>
                            <div id="chart_inco">
                                <apexchart ref="max" type="heatmap" height="400" :options="chartOptions_max" :series="[]"></apexchart>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>

                <!--
    5- Horas de uso del sistema: desde primera lectura del dia hasta la ultima descontado los periodos de NNET o hasta siguiente MEAS
	menos de 6h: Azul c5cae9
	6h a 18h: Azul 7d89cd
	mas de 18: Azul 3f51b5
    -->
                <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">

                    <md-card>
                        <md-card-header class="md-card-header-text md-card-header-green">
                            <div class="card-text">
                                <h4 class="title">{{$t("g_hora_uso")}}</h4>
                            </div>
                        </md-card-header>
                        <md-card-content>
                            <div id="chart_inco">
                                <apexchart ref="uso" type="heatmap" height="400" :options="chartOptions_uso" :series="[]"></apexchart>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>

                <!--
    6- Fueras cobertura: numero de NNET al dia: 
	menos de 6: Azul 7d89cd
	6 a 12: Naranja ffa500
	mas de 12: rojo ff0000
    -->
                <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">

                    <md-card>
                        <md-card-header class="md-card-header-text md-card-header-green">
                            <div class="card-text">
                                <h4 class="title">{{$t("g_cobertura")}}</h4>
                            </div>
                        </md-card-header>
                        <md-card-content>
                            <div id="chart_inco">
                                <apexchart ref="cobertura" type="heatmap" height="400" :options="chartOptions_cobertura" :series="[]"></apexchart>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>
            </div>
        </md-card-content>
    </md-card>

</div>
</template>

<style>
.month-picker__container {
    background-color: white;
    z-index: 9999999 !important;
}
</style>

<script>
let BACKEND_API = process.env.VUE_APP_BACKEND_API;
import { authHeader } from "../../helpers/auth-header";
import { handleResponse } from "../../helpers/handle-response";
import { MonthPickerInput } from "vue-month-picker";
import jsPDF from "jspdf";

export default {
    name: "analytics",
    components: {
        MonthPickerInput,
    },
    mounted() {
        //this.fetchData();
    },
    data() {
        return {
            currentChartIndex: 0,
            locale: this.$i18n.locale,
            selectedDate: this.$moment(new Date()),
            fetching: false,
            chartOptions_inco: {
                noData: {},
                chart: {
                    type: "heatmap",
                    animations: {
                        enabled: false,
                    },
                },
                stroke: {
                    width: 0,
                },
                plotOptions: {
                    heatmap: {
                        radius: 30,
                        enableShades: false,
                        colorScale: {
                            ranges: [
                                {
                                    from: -1,
                                    to: 0,
                                    color: "#FFFFFF",
                                    border: "#000000",
                                },
                                {
                                    from: 1,
                                    to: 5,
                                    color: "#7d89cd",
                                },
                                {
                                    from: 6,
                                    to: 12,
                                    color: "#ffa500",
                                },
                                {
                                    from: 13,
                                    to: 100,
                                    color: "#ff0000",
                                },
                            ],
                        },
                    },
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        colors: ["#fff"],
                    },
                },
                tooltip: {
                    enabled: false,
                },
                xaxis: {
                    type: "category",
                },
                title: {
                    text: "",
                },
            },
            chartOptions_soiled: {
                noData: {},
                chart: {
                    type: "heatmap",
                    animations: {
                        enabled: false,
                    },
                },
                stroke: {
                    width: 0,
                },
                plotOptions: {
                    heatmap: {
                        radius: 30,
                        enableShades: false,
                        colorScale: {
                            ranges: [
                                {
                                    from: -1,
                                    to: 0,
                                    color: "#FFFFFF",
                                    border: "#000000",
                                },
                                {
                                    from: 0,
                                    to: 1,
                                    color: "#7d89cd",
                                },
                                {
                                    from: 1,
                                    to: 3,
                                    color: "#ffa500",
                                },
                                {
                                    from: 3,
                                    to: 100,
                                    color: "#ff0000",
                                },
                            ],
                        },
                    },
                },
                tooltip: {
                    enabled: false,
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        colors: ["#fff"],
                    },
                },
                xaxis: {
                    type: "category",
                },
                title: {
                    text: "",
                },
            },
            chartOptions_max: {
                noData: {},
                chart: {
                    type: "heatmap",
                    animations: {
                        enabled: false,
                    },
                },
                stroke: {
                    width: 0,
                },
                plotOptions: {
                    heatmap: {
                        radius: 30,
                        enableShades: false,
                        colorScale: {
                            ranges: [
                                {
                                    from: -1,
                                    to: 0,
                                    color: "#FFFFFF",
                                    border: "#000000",
                                },
                                {
                                    from: 100,
                                    to: 1000,
                                    color: "#7d89cd",
                                    foreColor: "#7d89cd",
                                },
                                {
                                    from: 19,
                                    to: 100,
                                    color: "#e5e619",
                                    foreColor: "#e5e619",
                                },
                                {
                                    from: 7,
                                    to: 19,
                                    color: "#ffa500",
                                    foreColor: "#ffa500",
                                },
                                {
                                    from: 0,
                                    to: 7,
                                    color: "#ff0000",
                                    foreColor: "#ff0000",
                                },
                            ],
                        },
                    },
                },
                tooltip: {
                    enabled: false,
                },
                legend: {
                    show: false
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        colors: ["#fff"],
                    },
                },
                xaxis: {
                    type: "category",
                },
                title: {
                    text: "",
                },
            },
            chartOptions_uso: {
                noData: {},
                chart: {
                    type: "heatmap",
                    animations: {
                        enabled: false,
                    },
                },
                stroke: {
                    width: 0,
                },
                plotOptions: {
                    heatmap: {
                        radius: 30,
                        enableShades: false,
                        colorScale: {
                            ranges: [
                                {
                                    from: -1,
                                    to: 0,
                                    color: "#FFFFFF",
                                    border: "#000000",
                                },
                                {
                                    from: 0,
                                    to: 6,
                                    color: "#c5cae9",
                                },
                                {
                                    from: 6,
                                    to: 18,
                                    color: "#7d89cd",
                                },
                                {
                                    from: 18,
                                    to: 24,
                                    color: "#3f51b5",
                                },
                            ],
                        },
                    },
                },
                tooltip: {
                    enabled: false,
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        colors: ["#fff"],
                    },
                },
                xaxis: {
                    type: "category",
                },
                title: {
                    text: "",
                },
            },
            chartOptions_cobertura: {
                noData: {},
                chart: {
                    type: "heatmap",
                    animations: {
                        enabled: false,
                    },
                },
                stroke: {
                    width: 0,
                },
                plotOptions: {
                    heatmap: {
                        radius: 30,
                        enableShades: false,
                        colorScale: {
                            ranges: [
                                {
                                    from: -1,
                                    to: 0,
                                    color: "#FFFFFF",
                                    border: "#000000",
                                },
                                {
                                    from: 0,
                                    to: 6,
                                    color: "#7d89cd",
                                },
                                {
                                    from: 6,
                                    to: 12,
                                    color: "#ffa500",
                                },
                                {
                                    from: 12,
                                    to: 100,
                                    color: "#ff0000",
                                },
                            ],
                        },
                    },
                },
                tooltip: {
                    enabled: false,
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        colors: ["#fff"],
                    },
                },
                xaxis: {
                    type: "category",
                },
                title: {
                    text: "",
                },
            },
        };
    },
    methods: {
        destroy() {
            this.$refs.inco.destroy();
            this.$refs.soiled.destroy();
            this.$refs.max.destroy();
            this.$refs.cobertura.destroy();
            this.$refs.uso.destroy();
        },
        fetchData() {
            //this.fetching = true;
            let month = this.selectedDate.monthIndex;
            if (month < 10) {
                month = "0" + month;
            }
            let fecha = this.selectedDate.year + "-" + month + "-01";

            let url = `${BACKEND_API}/api/monthly-report/overview/` + fecha;
            let currentCentro = JSON.parse(sessionStorage.getItem("idCentro"));
            if (currentCentro) {
                url = url + "/" + currentCentro.id;
            }
            fetch(url, {
                method: "GET",
                headers: authHeader(),
            })
                .then(handleResponse)
                .then((response) => {
                    //this.$refs.inco.updateSeries(response.chart_inco);
                    //this.$refs.soiled.updateSeries(response.chart_atencion);
                    //this.$refs.max.updateSeries(response.chart_max_dia);
                    //this.$refs.cobertura.updateSeries(response.chart_cobertura);
                    //this.$refs.uso.updateSeries(response.chart_hora_uso);

                    //Ratio
                    let ratio = 62.5;
                    let alto = response.chart_inco.length * ratio;
                    if (alto < 100) {
                        alto = alto + 100;
                    }
                    let newOptions = {
                        width: "900",
                        height: "450",
                        type: "heatmap",
                        animations: {
                            enabled: false,
                        },
                    };
                    this.$refs.inco.updateOptions({
                        chart: newOptions,
                        series: response.chart_inco,
                        tooltip: {
                            enabled: true,
                        },
                    });
                    this.$refs.soiled.updateOptions({
                        chart: newOptions,
                        series: response.chart_atencion,
                        tooltip: {
                            enabled: true,
                        },
                    });
                    this.$refs.max.updateOptions({
                        chart: newOptions,
                        series: response.chart_max_dia,
                        tooltip: {
                            enabled: true,
                        },
                    });
                    this.$refs.cobertura.updateOptions({
                        chart: newOptions,
                        series: response.chart_cobertura,
                        tooltip: {
                            enabled: true,
                        },
                    });
                    this.$refs.uso.updateOptions({
                        chart: newOptions,
                        series: response.chart_hora_uso,
                        tooltip: {
                            enabled: true,
                        },
                    });

                    //this.fetching = false;
                });
        },
        print() {
            let pdfName = "test";
            var pdf = new jsPDF();
            let name = "Monthly Report (" + this.selectedDate.month + ")";
            pdf.text(name, 10, 10);
            let self = this;

            let charts = ["inco", "soiled", "max", "uso", "cobertura"];
            let titles = [
                "g_inco",
                "g_max",
                "g_max_alc",
                "g_hora_uso",
                "g_cobertura",
            ];
            let alturas = [20, 150, 20, 150, 20];
            charts.forEach((value, index) => {
                this.$refs[value].dataURI().then(({ imgURI, blob }) => {
                    if ((index + 1) % 2 && index + 1 > 2) {
                        pdf.addPage();
                    }
                    this.currentChartIndex = index;
                    pdf.text(this.$t(titles[index]), 10, alturas[index]);
                    pdf.addImage(
                        imgURI,
                        "PNG",
                        0,
                        alturas[index] + 5,
                        200,
                        120,
                        undefined,
                        "FAST"
                    );
                    if (this.currentChartIndex == charts.length - 1) {
                        pdf.save(name + ".pdf");
                    }
                });
            });
        },
    },
};
</script>
